import React from "react";

export default (props) => {
    
    const { eventHandle } = props;

    return (
        <div className="gauge-add-btn" style={{border:"1px solid #eee", borderRadius:"10px", display:"block", marginBottom:"1.4rem", padding:"16px 0 10px 0"}}>
            <a onClick={eventHandle} className="btn-circleplus">
                <i></i>
                <p>추가등록</p>
            </a>
        </div>
    )
}